import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexColCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../General/Text';
import InfoRow from './InfoRow';
import { PriceInfo } from './PriceInfo';
import { CountSetter } from './CountSetter';
// import { ButtonPrimary } from '../General/Button';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { ProductDetailSelect as Select } from './Select';
import { StockInfo } from '../Product/StockInfo';
import { TextP } from '../../Defaults/Text';
import { getZlataPriadkaSymbolData } from '../selectors';
import { Button } from '../General/Button';
import { getImagePath } from '../../../utilities';

interface Good {
  good_id: number;
  attribs: Array<{
    attrib_id: number;
    attrib_value: string;
    value_id: number;
    attrib_name: string;
  }>;
}

interface SelectProps {
  name: string;
  value: string;
  image?: string;
}

interface Props {
  id: number;
  title: string;
  description: string;
  plu: string;
  onStock: number;
  price: number | string;
  oldPrice: number | string;
  currency: string;
  unit: string;
  count: number;
  addToCart: any;
  handleCountChange: (newValue) => void;
  handleGoodChange: any;
  symbols: string[];
  productInfo: any;
  toggleFavourite: any;
  favouriteProducts: any;
  alternativeProducts: any[];
  image: string;
  url: string;
}

function RightUpper({
  id,
  title,
  description,
  onStock,
  price,
  oldPrice,
  currency,
  unit,
  count,
  addToCart,
  handleCountChange,
  handleGoodChange,
  plu,
  symbols,
  productInfo,
  toggleFavourite,
  favouriteProducts,
  alternativeProducts,
  url,
  image,
}: Props) {
  const onChange = event => {
    const newUrl = event.value;
    handleGoodChange(newUrl);
  };

  const handleClick = () => {
    addToCart();
  };

  const [isShowingAll, setIsShowingAll] = React.useState(false);
  const descSize = 150;
  const mobileDescription =
    description && description.length > descSize
      ? description.substr(0, descSize) + '...'
      : null;

  const step = unit === 'm' ? 0.1 : 1;

  const toggleShowingAll = () => {
    setIsShowingAll(!isShowingAll);
  };

  const optionsVariants: SelectProps[] = [];

  // variants.forEach(v => {
  //   const good_id = v.good_id;
  //   if (v.attribs && v.attribs.length > 0) {
  //     v.attribs.forEach(a => {
  //       if (a.attrib_name === 'Farba') {
  //         const obj: SelectProps = {
  //           name: `${a.attrib_value}`,
  //           value: good_id.toString(),
  //         };
  //         optionsVariants.push(obj);
  //       }
  //     });
  //   }
  // });

  if (alternativeProducts && alternativeProducts.length) {
    optionsVariants.push({
      name: title,
      value: url,
      image: getImagePath(process.env.REACT_APP_API_BASE_URL as string, image),
    });
  }
  alternativeProducts.forEach(p => {
    optionsVariants.push({
      name: p.name,
      value: `/${p.url}`,
      image: getImagePath(
        process.env.REACT_APP_API_BASE_URL as string,
        p.picture,
      ),
    });
  });

  const bottomPartDesktop = () => {
    return (
      <>
        {optionsVariants && optionsVariants.length > 0 && (
          <Variants>
            <Select
              options={optionsVariants}
              onChange={onChange}
              marginBottom={56}
            />
          </Variants>
        )}
        <PriceInfo
          price={price}
          oldPrice={oldPrice}
          currency={currency}
          toggleFavourite={toggleFavourite}
          favouriteProducts={favouriteProducts}
          productId={id}
          unit={unit}
        />
        <PartWrapper>
          <CountSetter
            step={step}
            unit={unit}
            count={count}
            onChange={handleCountChange}
            onStock={onStock}
            type={'product'}
          />
          <CartButton onClick={handleClick} disabled={onStock <= 0}>
            <SvgIcon
              width={24}
              height={24}
              icon={IconType.cart}
              fill={'#FFFFFF'}
              alt={__('Košík')}
              title={__('Košík')}
              cursor={'pointer'}
            />
            <Text>{__('Do košíka')}</Text>
          </CartButton>
        </PartWrapper>
        <StockOrderNumberWrapper>
          <StockInfo onStock={onStock} />
          {__('Obj. číslo: ')}
          {plu === '' ? 'Bez EAN kódu' : plu}
        </StockOrderNumberWrapper>
        <ProductDetailsWrapper>
          <ProductDetailsIconsWrapper>
            {symbols.map((symbol, i) => {
              return (
                <IconWrapper key={i}>
                  <SvgIcon
                    width={32}
                    height={32}
                    viewBox={'0 0 32 32'}
                    icon={getZlataPriadkaSymbolData(symbol).type}
                    fill={'#07151C'}
                    alt={__('Symbol')}
                    title={getZlataPriadkaSymbolData(symbol).tooltip}
                  />
                </IconWrapper>
              );
            })}
          </ProductDetailsIconsWrapper>
          {productInfo.map((info, i) => {
            return <InfoRow key={i} title={info.title} value={info.value} />;
          })}
        </ProductDetailsWrapper>
      </>
    );
  };

  const bottomPartMobile = () => {
    return (
      <>
        {optionsVariants && optionsVariants.length > 0 && (
          <Variants>
            <Select options={optionsVariants} onChange={onChange} />
          </Variants>
        )}
        <PriceInfo
          price={price}
          oldPrice={oldPrice}
          currency={currency}
          toggleFavourite={toggleFavourite}
          favouriteProducts={favouriteProducts}
          productId={id}
        />
        <PartWrapper>
          <CountSetter
            step={step}
            unit={unit}
            count={count}
            onChange={handleCountChange}
            onStock={onStock}
            type={'product'}
          />
          <CartButton onClick={handleClick} disabled={onStock <= 0}>
            <SvgIcon
              width={24}
              height={24}
              icon={IconType.cart}
              fill={'#FFFFFF'}
              alt={__('Košík')}
              title={__('Košík')}
              marginRight={12}
            />
            <Text>{__('Do košíka')}</Text>
          </CartButton>
        </PartWrapper>
        <StockOrderNumberWrapper>
          <StockInfo onStock={onStock} />
          <OrderText>
            {__('Obj. číslo: ')}
            {plu === '' ? 'Bez EAN kódu' : plu}
          </OrderText>
        </StockOrderNumberWrapper>
        <ProductDetailsWrapper>
          <ProductDetailsIconsWrapper>
            {symbols.map((symbol, i) => {
              return (
                <IconWrapper key={i}>
                  <SvgIcon
                    width={32}
                    height={32}
                    viewBox={'0 0 32 32'}
                    icon={getZlataPriadkaSymbolData(symbol).type}
                    fill={'#07151C'}
                    alt={__('Symbol')}
                    title={getZlataPriadkaSymbolData(symbol).tooltip}
                  />
                </IconWrapper>
              );
            })}
          </ProductDetailsIconsWrapper>
          {productInfo.map((info, i) => {
            return <InfoRow key={i} title={info.title} value={info.value} />;
          })}
        </ProductDetailsWrapper>
      </>
    );
  };

  const rightUpperContent = (isMobileContent: boolean) => {
    const descr =
      !isShowingAll && mobileDescription && isMobileContent
        ? mobileDescription
        : description;
    const markup = descr ? descr.replace(/style=".*?"/gi, '') : '';
    return (
      <>
        <ProductTitle marginTop={0} marginBottom={24}>
          {title}{' '}
        </ProductTitle>
        {description && typeof description === 'string' && (
          <>
            <Description
              short={isShowingAll}
              dangerouslySetInnerHTML={{ __html: markup }}
            />
            <ShowMoreWrapper onClick={toggleShowingAll}>
              {isShowingAll ? __('Skryť') : __('Zobraziť popis')}
              <SvgIcon
                cursor={'pointer'}
                width={16}
                height={16}
                marginLeft={8}
                fill={'#07151C'}
                rotate={isShowingAll ? 180 : 0}
                alt="arrow-icon"
                icon={IconType.downArrow}
              />
            </ShowMoreWrapper>
          </>
        )}
        <MobilePartWrapper>{bottomPartMobile()}</MobilePartWrapper>
        <DesktopPartWrapper>{bottomPartDesktop()}</DesktopPartWrapper>
      </>
    );
  };
  return (
    <>
      <DesktopWrapper>{rightUpperContent(false)}</DesktopWrapper>
      <MobileWrapper>{rightUpperContent(true)}</MobileWrapper>
    </>
  );
}

const DesktopPartWrapper = styled.div`
  display: block;
  // margin-top: ${rem(36)};

  ${({ theme }) => theme.mediab.s450`
    display: none;
  `}
`;

const MobilePartWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.mediab.s450`
    display: block;
  `}
`;
const Wrapper = styled(FlexCol)`
  width: 40%;
  margin: 0 ${rem(64)};

  ${({ theme }) => theme.mediab.l1050`
     margin: 0 ${rem(24)};
  `}

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    width: 100%;
  `}

  ${({ theme }) => theme.mediab.s450`
    margin: 0;
  `}
`;

const DesktopWrapper = styled(Wrapper)`
  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const MobileWrapper = styled(Wrapper)`
  display: none;

  ${({ theme }) => theme.mediab.l925`
   display: flex;
   max-width: ${rem(600)};
   margin: 0 auto ${rem(26)} auto;
  `}
`;

const StockOrderNumberWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.colors.textPrimary};
  opacity: 0.56;
`;

const Text = styled(TextP)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.white};
  margin-left: ${rem(12)};

  ${({ theme }) => theme.mediab.s450`
    display: none;
    margin: 0;
  `}
`;

const OrderText = styled(TextP)`
  display: inline-block;
  text-decoration: none;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  font-weight: 300;
  opacity: 0.56;
`;

const ProductDetailsIconsWrapper = styled(FlexRowCenterVertical)`
  margin-top: ${rem(56)};
  margin-bottom: ${rem(24)};
`;

const PartWrapper = styled(FlexRowCenterVertical)`
  background: ${({ theme }) => theme.colors.secondaryBackground};
  border-radius: ${rem(8)};
  margin: ${rem(24)} 0;
  justify-content: start;
  width: 100%;
  padding: ${rem(24)};

  ${({ theme }) => theme.mediab.s450`
    padding: ${rem(16)};
  `}
`;

const ProductDetailsWrapper = styled(FlexColCenterVertical)``;

const CartButton = styled(Button)`
  width: 100%;
  background: ${({ theme }) => theme.colors.secondary};
  text-transform: none;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  margin-left: ${rem(24)};

  &:disabled {
    background-color: #dcd6d6;
    color: ${({ theme }) => theme.colors.black};

    svg {
      fill: ${({ theme }) => theme.colors.black};

      * {
        fill: inherit;
      }
    }

    &:hover,
    &:focus {
      background-color: #dcd6d6;
      outline: none;
    }
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.secondaryOnHover};
    outline: none;
  }

  ${({ theme }) => theme.mediab.s450`
    margin-left: ${rem(16)};
  `}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem(48)};
  width: ${rem(48)};
  border: ${rem(2)} solid #eeeeee;
  border-radius: ${rem(4)};
  margin-right: ${rem(8)};
`;

const Description = styled.div<{ short: boolean }>`
  margin-bottom: ${rem(32)};
  font-size: ${rem(16)} !important;
  font-family: ${({ theme }) => theme.font.primary} !important;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(28)};

  ${({ theme }) => theme.mediab.s450`
    font-size: ${rem(14)};
    line-height: ${rem(24.5)};
    margin-bottom: ${rem(16)};

    max-height: ${({ short }) => (short ? '' : rem(56))};
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: hidden;
  `};
`;

const ProductTitle = styled(Title)`
  font-family: ${({ theme }) => theme.font.secondary};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(30)};
  line-height: ${rem(39)};
  font-weight: 500;
  margin-bottom: ${rem(32)};
`;

const Variants = styled.div`
  margin-top: ${rem(24)};

  ${({ theme }) => theme.mediab.s450`
    margin-top: 0;
  `};
`;

const ShowMoreWrapper = styled(FlexRowCenterVertical)`
  display: none;
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  width: fit-content;
  cursor: pointer;
  margin-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.l925`
    display: flex;
  `};
`;

export { RightUpper };
